'use strict';
const _ = require('underscore'),
	progressAttributeNames = require('./progress-attribute-names'),
	measurementsAttributeNames = require('./measures-attribute-names');
module.exports = function ProgressStatusCalculator() {
	const self = this,
		getConfig = function (activeContent) {
			return activeContent && activeContent.attr && activeContent.attr[progressAttributeNames.statusConfigAttr] || {};
		},
		getMeasurementConfig = function (activeContent) {
			return activeContent && activeContent.attr && activeContent.attr[measurementsAttributeNames.configurationAttributeName] || [];
		};

	self.getProjectionsFor = function (activeContent) {
		const projections = [],
			statusConfig = getConfig(activeContent),
			dataTotaliser = function () {
				return _.reduce(this, function (val, row) {
					return val + row[1];
				}, 0);
			},
			buildPercentProjection = function (name, wrappedProjection) {
				return {
					name: name,
					iterator: function (originalData, activeContent) {
						const data = wrappedProjection(originalData, activeContent),
							total = _.reduce(data, function (valueSoFar, item) {
								return valueSoFar + item[1];
							}, 0);
						if (total === 0) {
							return [];
						}
						return _.map(data, function (item) {
							const percent = (100 * item[1] / total).toFixed(0) + '%';
							return [item[0], percent];
						});
					}
				};
			},
			buildSumByStatusProjection = function (name, itemValue) {
				return {
					name: name,
					iterator: function (data) {
						const rawCounts = function () {
								const currentCounts = {};
								_.each(data, function (element) {
									let val = 1;
									const current = currentCounts[element.status] || 0;
									if (itemValue) {
										val = itemValue(element);
									}
									if (val) {
										currentCounts[element.status] = current + val;
									}

								});
								return currentCounts;
							},
							flattened = _.map(rawCounts(), function (v, k) {
								return [k, v];
							}),
							sorted = flattened.sort(function (row1, row2) {
								const config1 = statusConfig[row1[0]] || {},
									config2 = statusConfig[row2[0]] || {},
									priority1 = config1.priority || 0,
									priority2 = config2.priority || 0;
								if (priority1 === priority2) {
									return config1.description.localeCompare(config2.description);
								} else {
									return priority2 - priority1;
								}
							});
						_.each(sorted, function (row) {
							row[0] = (statusConfig[row[0]] && statusConfig[row[0]].description) || row[0];
						});
						sorted.total = dataTotaliser;
						return sorted;
					}
				};
			};
		projections.push(buildSumByStatusProjection('Counts'));
		projections.push(buildPercentProjection('Percentages', projections[0].iterator));
		_.each(getMeasurementConfig(activeContent), function (measurement) {
			const totalProjection = buildSumByStatusProjection('Total ' +  measurement, function (item) {
				const val = parseFloat(item.measurements && item.measurements[measurement]) || 0;
				return val;
			});
			projections.push(totalProjection);
			projections.push(buildPercentProjection('Percentage ' + measurement, totalProjection.iterator));
		});
		return projections;
	};

	self.dataAdapter = function (activeContent, filter) {
		const statusConfig = activeContent && activeContent.attr && activeContent.attr[progressAttributeNames.statusConfigAttr] || {},
			result = [];
		filter = filter || {};
		if (filter.subtree) {
			activeContent = activeContent.findSubIdeaById(filter.subtree()) || activeContent;
		}
		activeContent.traverse(function (idea) {
			const stat = idea.attr && idea.attr[progressAttributeNames.statusAttributeName];
			let resultItem;
			if (!filter.includeParents && _.find(idea.ideas, function (subidea) {
				return subidea.attr && subidea.attr[progressAttributeNames.statusAttributeName] === stat;
			})) {
				return;
			}
			if (stat && statusConfig[stat] && (!filter.statuses  || _.include(filter.statuses, stat))) {
				resultItem = {status: stat, id: idea.id};
				if (idea.title) {
					resultItem.title = idea.title;
				}
				if (idea.attr && idea.attr[measurementsAttributeNames.measurementAttributeName]) {
					resultItem.measurements = idea.attr[measurementsAttributeNames.measurementAttributeName];
				}
				result.push(resultItem);
			}
		});
		return result;
	};
};
